import ColumnTypes from '@/utils/ColumnTypes';
function getColums(){
    let arr = [
        {
            label: '店铺名称',
            type: () => import('./components/tableCell/shopStrore.vue'),
            minWidth: 265,
        },
        {
            key:'outerShopId',
            label: '店铺ID',
            type: ColumnTypes.TextCell,
            minWidth: 265,
        },
        {
			key: 'operations',
			label: '操作',
			type: ColumnTypes.ButtonsCell,
			minWidth: '100',
			
		}
    ]
    return arr
}
export default getColums